import React from 'react';

import S from 'app/features/newLanding/components/newProductComparison/Product/Benefit.styled';

const BenefitCrownIcon = () => (
  <S.Benefit.Crown
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    data-t="crown-svg"
    aria-labelledby="crown-svg"
    role="img"
  >
    <title id="crown-svg">Crown</title>
    <path
      transform="translate(3, 2)"
      d="M2.419 13L0 4.797l4.837 2.144L8 2l3.163 4.941L16 4.797 13.581 13z"
    />
  </S.Benefit.Crown>
);

export default BenefitCrownIcon;
